import { RootState } from "../Store";

export const selectStore = (state: RootState) => state.store.store;

export const selectorAllStores = (state: RootState) =>
  state.storesManager.stores;
